{
  "columns": [
    {
      "header_id": "tasTimesheetlineDetailId",
      "header_label": "Timesheet Line Id",
      "jsonpath": "tasTimesheetlineDetailId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "consumerName",
      "header_label": "Consumer Name",
      "jsonpath": "consumerName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "participantPplId",
      "header_label": "Consumer PPL ID",
      "jsonpath": "participantPplId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "providerName",
      "header_label": "PA Name",
      "jsonpath": "providerName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "providerPplId",
      "header_label": "PA PPL ID",
      "jsonpath": "providerPplId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "fromDate",
      "header_label": "From Date",
      "jsonpath": "fromDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "toDate",
      "header_label": "To Date",
      "jsonpath": "toDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "serviceDate",
      "header_label": "Service Date",
      "jsonpath": "serviceDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "createdDate",
      "header_label": "Submission Date",
      "jsonpath": "createdDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "serviceDescription",
      "header_label": "Service Description",
      "jsonpath": "serviceDescription",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "timeIn",
      "header_label": "Time In",
      "jsonpath": "timeIn",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "timeOut",
      "header_label": "Time Out",
      "jsonpath": "timeOut",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "billedUnits",
      "header_label": "Billed Units(15 Mins Increment)",
      "jsonpath": "billedUnits",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "billedUnitsInHrs",
      "header_label": "Billed Units(hrs)",
      "jsonpath": "billedUnitsHrs",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "paidUnits",
      "header_label": "Paid Units (hrs)",
      "jsonpath": "paidUnitsHrs",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "serviceRate",
      "header_label": "Service Rate",
      "jsonpath": "serviceRate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    },
    {
      "header_id": "source_type_lkp",
      "header_label": "Timesheet Source",
      "jsonpath": "source_type_lkp",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "mco_name",
      "header_label": "MCO Name",
      "jsonpath": "mco_name",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    }
  ],
  "buttons": [{
    "button_id":"submit_for_processing",
    "button_label":"Submit for Payroll Processing",
    "buttonAction" : "submit_for_processing",
    "className": "primary-btn-color"
  }],
  "apiDetails": "payrollprocessinglist.json",
  "pageName": "payrollprocessinglist",
  "orderByColumn": [],
  "orderBy": ["desc"]
}